import React from 'react'
import EditCardNavbar from 'components/editCard/editCardTopNavbar/EditCardNavbar'
import EditCardDashboard from 'components/editCard/EditCardDashboard'

const EditCard = ({ user })=> {
  return (
    <div>
      <EditCardNavbar user={user} />
      <EditCardDashboard user={user}/>
      </div>
  )
}

export default EditCard